import React from 'react'
import './pages.css'

function Setting() {
    return (
        <div className='setting'>
           <h1>Choose your theme!</h1>
        </div>
    );
}

export default Setting